<template>
  <div class="main-box">
    <!--<application-detail />-->
    <digital-application />
  </div>
</template>

<script>
  // import ApplicationDetail from '@/components/application/ApplicationDetail.vue'
  import DigitalApplication from '@/components/application/DigitalApplication/DigitalApplication.vue'

  export default {
    components: {
      // ApplicationDetail
      DigitalApplication
    }
  }
</script>
